import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

const queryString = require("query-string")

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-orgs-people
 */
export function getOrgPeople(orgId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs/${orgId}/people?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
